import React from 'react';
import BzFormControlWithHook from 'components/forms/BzFormControlWithHook';
import { CallbackFn, useFormInput, ValidatorType } from 'hooks/useFormInput';
import _ from 'lodash';
import i18n from 'i18n';

type IterationCountProps = {
  disabled: boolean;
  value: number;
  onChange: (value: any) => void;
};
const IterationCount = (props: IterationCountProps) => {
  const validationMsg = i18n.t('dataSettings:dataModel.validation');
  const iterationCountHook = useFormInput(
    props.value,
    (fn: CallbackFn) => (fn.isValid ? props.onChange(fn.value) : _.noop()),
    {
      type: ValidatorType.REQUIRED,
      invalidMessage: 'Required',
    },
    {
      type: ValidatorType.MIN,
      value: 1,
      invalidMessage: validationMsg,
    },
  );

  return (
    <BzFormControlWithHook
      disabled={props.disabled}
      useFormInputHook={iterationCountHook}
      placeholder={i18n.t('dataSettings:dataModel.numberOfIterations')}
      required={false}
    />
  );
};

export default IterationCount;
